import {
  faBriefcase,
  faBuilding,
  faMapMarked,
  faMoneyBill,
} from '@fortawesome/free-solid-svg-icons';
import Button from '@atlaskit/button';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { get, isEmpty } from 'lodash';

import {
  Container,
  Title,
  TitleItems,
  TitleLocation,
  Row,
  Main,
  Tag,
} from './styles';
import { faAccessibleIcon } from '@fortawesome/free-brands-svg-icons';

function CardVacancy({ vacancy, primaryColor, params, query }) {
  const castRegime = regime => {
    if (!regime) return '';
    if (['pessoa jurídica'].includes(regime.toString().toLowerCase())) {
      return 'PJ';
    }
    return regime;
  };

  const href = useMemo(() => {
    const { label = '', page_label = '' } = query;

    return !isEmpty(label) && !isEmpty(page_label)
      ? `/${label}/${page_label}/vacancy/${vacancy.id}-${vacancy.slug}`
      : `/${label}/vacancy/${vacancy.id}-${vacancy.slug}`;
  }, [query, vacancy]);

  return (
    <Main href={href} primaryColor={primaryColor}>
      <Container>
        <Title>
          <div style={{ width: 'intial', display: 'flex', gap: '8px' }}>
            {vacancy.pcd && (
              <Tag>
                <h3>
                  <FontAwesomeIcon icon={faAccessibleIcon} />
                </h3>
              </Tag>
            )}
            {vacancy?.title}
            {get(vacancy, 'is_inclusive', 0) === 1 ? (
              <span className="inclusive">Vaga afirmativa</span>
            ) : null}
          </div>
          {!['Não Informado', 'Nenhum', 'Não informado', 'nenhum'].includes(
            vacancy?.regime
          ) &&
            vacancy?.regime &&
            vacancy?.show_regime === 1 && (
              <Tag>
                <h3>{castRegime(vacancy.regime)}</h3>
              </Tag>
            )}
        </Title>

        <Row style={{ justifyContent: 'space-between' }}>
          {vacancy?.client && vacancy?.show_client === 1 && (
            <TitleItems>
              <FontAwesomeIcon icon={faBriefcase} />
              {vacancy?.client?.name}
            </TitleItems>
          )}
          {vacancy?.location && (
            <TitleLocation>
              <FontAwesomeIcon icon={faMapMarked} />
              {Array.isArray(vacancy?.location)
                ? vacancy?.location.length >= 2
                  ? `${vacancy?.location[0]}, ${vacancy?.location[1]}`
                  : vacancy?.location
                : vacancy?.location}
            </TitleLocation>
          )}
        </Row>
      </Container>
    </Main>
  );
}

CardVacancy.propType = {
  vacancy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    location: PropTypes.string,
    client: PropTypes.string,
    type: PropTypes.string,
    remunaration: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onClickSubscribe: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
};

export default CardVacancy;
